import React from "react";
import Checkout from "../components/checkout/Checkout";
import Nav from "../components/NavBar";

const Payment = () => {
     return ( 
          <>
               <Nav />
               <br /><br />
               <Checkout />
          </>   
      );
}
 
export default Payment;